export type PayType = 1 | 2 | 3 | 17 | 9; // 支付方式, 1: 现金, 2: 会员卡扣, 3: 扫码支付(支付宝/微信), 17: 选住余额，18:付款单

export enum PayWay {
  Cash = 1,
  Member = 2,
  Scan = 3,
  Xuanzhu = 17,
  Fukuandan = 9,
}
// export type PaymentType = 1 | 2; // 交易类型, 1: 收款, 2: 退款, 3: 先收后退

export type BusinessType = 1 | 2 | 3 | 4; // 收款业务类型, 1: 房间消费, 2: 购买会员卡, 3: 会员充值, 4: 前台直售

export type OrderType = 0 | 101 | 102 | 103 | 104; // 支付单类型, 101-充值; 102-押金; 103-销售; 104-结账

// export type ActionType = 1 | 2; // 收款动作类型，1: 收款, 2: 会员充值

export interface PaymentProps {
  excludePayWay?: Array<PayWay>;
  isInitPayTypes: boolean; // 是否获取收款方式
  selectPayType: (payType: PayType) => void; // 收款方式切换回调
  businessType?: BusinessType; // 收款业务类型
  resvNo?: string; // 主订单号(支持会员卡扣时必传)
  setIdCardNo?: (idCardNo: string) => void; // 身份证号(支持会员卡扣时必传)
  setWyuid?: (wyuid: string) => void;

  // supportPayTypes?: Array<PayType>; // 支持的支付方式，不传默认全部
  // payAmount?: number; // 退款金额
  // refundAmount?: number; // 退款金额
  // paymentType?: PaymentType; // 交易类型
  // extra?: ReactNode; // 额外信息(预结算需要)
  // payedAmount?: number; // 已支付金额(结账需要)
}

export type PayResult = {
  payed?: boolean; // 是否支付
  result?: boolean; // 支付结果
  type?: number; // 支付方式
  amount?: number; // 支付金额
  // actionType?: ActionType; // 支付动作类型
  generatePayOrder?: boolean; // 付款单是否生成成功
  closePayOrderModal?: boolean;
};

export interface PayModalProps {
  ref: any;
  payResultCallback: (result: PayResult) => void; // 支付结果回调函数
  onConfirmOk?: () => void;
  onConfirmCancel?: () => void;
}

export interface OpenPayModalProps {
  payType?: number; // 支付方式
  payAmount?: number; // 支付金额
  payOrderType?: OrderType; // 支付单类型
  paymentNo?: string; // 支付单号
  // payModalVisible: boolean; // 是否打开支付对话框
  // payResultCallback: (res: PayResult) => void; // 支付结果回调函数
  certNo?: string; // 身份证号(支持会员卡扣时必传)
  // actionType?: ActionType; // 收款动作类型
  accountType?: number; // 会员类型(会员充值用)
  wyuid?: string; // 网鱼id(会员充值用)
  rechargeAmount?: number; // 充值金额(会员充值用)
  rechargeGiving?: number; // 充值赠送金(会员充值用)
  businessType?: BusinessType; // 收款业务类型(1.6.1新增)
  showFukuanDanConfirm?: boolean;
  extraParams?: Object; // 附加参数
}

export interface PayModalRef {
  openModal: (params: OpenPayModalProps) => void;
}

export interface CashProps {
  payAmount: number;
  payModalVisible: boolean;
  inputCashCallback: ({ isValid: boolean, cash: number }) => void;
  submitCashPay: () => void;
}

export interface BarcodeProps {
  payModalVisible: boolean;
  barcodeLoading: boolean;
  submitBarcodePay: (code: string) => void;
}

// 会员信息
export type VipInfo = {
  accountType: number; // 会员账户类型
  balance: number; // 账户余额
  wyuid: string; // 身份标识
  isWyUser: boolean; // 是否网鱼电酒用户
  isVip: boolean; // 是否会员
};

export interface VipCardProps {
  certNo: string;
  wyuid: string;
  payAmount: number;
  payModalVisible: boolean;
  businessType: BusinessType;
  vipInfoChangeCallback: (info: VipInfo) => void;
  submitVipCardPay: (info: VipInfo) => void;
}

// 选住会员信息
export type XuanzhuVipInfo = {
  balance: number; // 账户余额
  wyuid: string; // 身份标识
};

export interface XuanZhuProps {
  certNo: string; // 证件号
  wyuid: string;
  payAmount: number;
  payModalVisible: boolean;
  balanceChangeCallback: (info: XuanzhuVipInfo) => void;
  submitXuanZhuPay: () => void;
}
